import React from "react";
import { Route } from "react-router-dom";

import { useIntl, defineMessages } from "react-intl";

import Dashboard from "../dashboard/dashboard";
import Page from "../common/page/page";
import Labourers from "../labourersList/labourers";
import WorkOrderDetails from "../admin/workOrderDetails";
import ManageLabourer from "../manageLabourers/manageLabourers";

const messages = defineMessages({
    settingsPageTitle: {
        id: "settings.title",
        defaultMessage: "Settings",
        description: "Settings page title",
    },
    settingsPageBreadcrumbs: {
        id: "settings.breadcrumbs",
        defaultMessage: "Back to home",
        description: "Settings breadcrumbs caption",
    },
});

function AdminRoutes() {
    const intl = useIntl();

    return (
        <>
            <Route exact path="/">
                <Dashboard />
            </Route>
            {process.env.REACT_APP_FEATURE_MANAGELABOURERS === "true" ? (
                <Route exact path="/settings">
                    <ManageLabourer />
                </Route>
            ) : (
                <Route exact path="/settings">
                    <Page
                        title={intl.formatMessage(messages.settingsPageTitle)}
                        breadcrumbText={intl.formatMessage(messages.settingsPageBreadcrumbs)}>
                        <Labourers />
                    </Page>
                </Route>
            )}
            <Route exact path="/workorderdetails/:workOrderNumber" component={WorkOrderDetails} />
        </>
    );
}

export default AdminRoutes;
